var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('PowraTitle', {
    attrs: {
      "avatar": 'D',
      "title": _vm.$vuetify.t('$vuetify.powra.anyOtherHazardsPresent')
    }
  }), _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-3": "",
      "mt-4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "",
      "outline": ""
    },
    on: {
      "blur": function blur($event) {
        return _vm.newHazard(_vm.hazardText);
      }
    },
    model: {
      value: _vm.hazardText,
      callback: function callback($$v) {
        _vm.hazardText = $$v;
      },
      expression: "hazardText"
    }
  })], 1), _c('v-dialog', {
    attrs: {
      "width": "500"
    },
    model: {
      value: _vm.dialog,
      callback: function callback($$v) {
        _vm.dialog = $$v;
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline indigo darken-4 white--text",
    attrs: {
      "primary-title": ""
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$vuetify.t('$vuetify.dialogs.delete.headline')) + "\n      ")]), _c('v-card-text', [_vm._v("\n        " + _vm._s(_vm.selectedHazard ? _vm.hazards[_vm.selectedHazard] : '') + "\n      ")]), _c('v-card-text', [_vm._v("\n        " + _vm._s(_vm.$vuetify.t('$vuetify.dialogs.delete.text')) + "\n      ")]), _c('v-divider'), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "color": "primary",
      "flat": ""
    },
    on: {
      "click": function click($event) {
        _vm.dialog = false;
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$vuetify.t('$vuetify.app.cancel')) + "\n        ")]), _c('v-btn', {
    attrs: {
      "color": "red"
    },
    on: {
      "click": function click($event) {
        _vm.selectedHazard ? _vm.deleteHazard(_vm.selectedHazard) : '';
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$vuetify.t('$vuetify.dialogs.delete.agree')) + "\n        ")])], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }